<template>
  <!-- 合作案例 投后数据报告 -->
  <div>
    <contenr/>
    <div class="detailContainer">
      <div class="part part1">
        <span class="topName">投后数据报告</span>
        <div class="topInfo">
          <span>订单号：{{getDrDetail.sericnum?getDrDetail.sericnum:'-'}} </span>
          <i></i>
          <span>发布时间：{{getDrDetail.publishtime?getDrDetail.publishtime:'-'}}</span>
        </div>
         <div class="content">
          <a class="backImg" :href="getDrDetail.video?getDrDetail.video.url:''" target="_blank">
              <img :src="getDrDetail.video?getDrDetail.video.head_image_uri:''" alt="">
          </a>
          <div class="contentDetail">
            <p><a :href="getDrDetail.video?getDrDetail.video.url:''" target="_blank">{{getDrDetail.video?getDrDetail.video.title:'-'}}</a></p>
            <!-- <span><a href="javascript:void(0);">123</a></span> -->
          </div>
          <div class="contentRight">
            <div class="rightItem">
              <span>{{getDrDetail.video?getDrDetail.video.play:'-'}}</span>
              <i>播放量</i>
            </div>
            <div class="rightItem">
              <span>{{getDrDetail.video?getDrDetail.video.like:'-'}}</span>
              <i>点赞量</i>
            </div>
            <div class="rightItem">
              <span>{{getDrDetail.video?getDrDetail.video.comment:'-'}}</span>
              <i>评论量</i>
            </div>
          </div>
        </div>
        <div class="grade">
        <span class="title">合作评价</span>
          <template v-if="evaluationBoxConfig">
            <EvaluationBox :config="evaluationBoxConfig"/>
          </template>
          <template v-else>
            <span class="title2">综合表现</span>
            <div class="gradeContent">
              <!-- <div class="scort">
                <el-rate
                  v-model="getDrDetail.score"
                  disabled
                  show-score
                  text-color="#ff9900">
                </el-rate>
              </div> -->
              <div class="tags2">
                <div class="tagItem">
                  <span>内容质量：</span>
                  <img v-if="getDrDetail.quality==='不满意'" src="./images/comment1.png" alt=""/>
                  <img v-if="getDrDetail.quality==='需关注'" src="./images/comment2.png" alt=""/>
                  <img v-if="getDrDetail.quality==='很满意'" src="./images/comment3.png" alt=""/>
                  <span>{{getDrDetail.quality}}</span>
                </div>
                <div class="tagItem">
                  <span>合作体验：</span>
                  <img v-if="getDrDetail.experience==='不满意'" src="./images/comment1.png" alt=""/>
                  <img v-if="getDrDetail.experience==='需关注'" src="./images/comment2.png" alt=""/>
                  <img v-if="getDrDetail.experience==='很满意'" src="./images/comment3.png" alt=""/>
                  <span>{{getDrDetail.experience}}</span>
                </div>
                <div class="tagItem">
                  <span>数据效果：</span>
                  <img v-if="getDrDetail.effect==='不满意'" src="./images/comment1.png" alt=""/>
                  <img v-if="getDrDetail.effect==='需关注'" src="./images/comment2.png" alt=""/>
                  <img v-if="getDrDetail.effect==='很满意'" src="./images/comment3.png" alt=""/>
                  <span>{{getDrDetail.effect}}</span>
                </div>
              </div>
            </div>
            <span class="title2">评价内容</span>
            <p class="comment">{{getDrDetail.evaluation?getDrDetail.evaluation:'无'}}</p>
          </template>
          <template v-if="agentAuth && !base_info.agent_reply">
           <div class="solid"></div>
           <div class="agentBox"><span class="agentReply">经纪人回复：</span><el-input type="textarea" autosize placeholder="请输入内容" v-model="agentReplyStr"></el-input><el-button type="primary" size="small" @click="agentReply" class="agentReplyBtn">回复</el-button></div>
          </template>
          <template v-if="base_info.agent_reply">
            <div class="agentReplyBoardBox">
              <div class="agentReplyBoard"><span class="agentReplyBoardTitle">经纪人回复：</span> {{base_info.agent_reply ? base_info.agent_reply:'无'}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contenr from "../content";
import tools from "../../components/tools/tools.js";

export default {
  name: "Detail",
  props:[],
  data(){
    return {
      orderID:0,
      getDrDetail:{},
      evaluationBoxConfig: null,
      agentReplyStr:'',
      base_info:{},
      agentAuth:null,
    }
  },
  computed:{
  },
  methods:{
    agentReply(){
      const params = {
          mid: this.$route.query.mid,
          origid: this.$route.query.origid,
          agent_reply: this.agentReplyStr,
        }
        this.$axios.get('/api.php?m=case|api|gx&a=agentReply', { params, headers: { showLoading: false } })
        .then(res => {
            this.$message.success('回复成功')
            this.agentReplyStr = ''
            this.initEvaluationBox()
        }).catch(err => {
          console.log('err :>> ', err);
        })

    },
    async initEvaluationBox(){
        const params = {
          mid: this.$route.query.mid,
          origid:  this.$route.query.origid
        }
        const res = await this.$axios.get('/api.php?m=case|api|gx&a=cooperationDetail', { params, headers: { showLoading: false } })
        const { base_info = {}, execution = {},agentAuth } = res
        this.base_info = base_info
        this.agentAuth = agentAuth
        console.log('base_info :>> ', base_info);
        if(base_info.evaluation_json){
          this.evaluationBoxConfig = JSON.parse(base_info.evaluation_json)
        }
    }
  },
  components:{
    contenr,
    EvaluationBox: ()=>import('@/pages/daren/Cooperation/EvaluationBox.vue'), //新版评价展示
  },
  created(){
    this.orderID = this.$route.query.id
    if(window.performance.navigation.type===0||window.performance.navigation.type===1||window.performance.navigation.type===2){
        //判断浏览器刷新行为，清除session
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
    }

    // 获取订单指数
    this.$api.getCooperationDetailData.getDrDetail('/'+this.orderID).then(async (res) => {
      let changeComment=function(commentData){
        let comment='-'
        for(let i=0;i<3;i++){
          if(commentData==='1'||commentData===1){
            comment='不满意'
          }else if(commentData==='2'||commentData===2){
            comment='需关注'
          }else if(commentData==='3'||commentData===3){
            comment='很满意'
          }
        }
        return comment
      }
      let getDrDetail = res.data.data
      await this.$api.getCooperationDetailData.getAuthorUri('?uri='+getDrDetail.video.cover_uri).then((res) => {
        console.log('uri :>> ', res.data.data.mainURL);
        getDrDetail.video.head_image_uri = res.data.data.mainURL||''
      })
      getDrDetail.video.play= getDrDetail.video.play? tools.setW(getDrDetail.video.play):'-'
      getDrDetail.video.share = getDrDetail.video.share?tools.setW(getDrDetail.video.share):'-'
      getDrDetail.video.like = getDrDetail.video.like?tools.setW(getDrDetail.video.like):'-'
      getDrDetail.video.comment = getDrDetail.video.comment?tools.setW(getDrDetail.video.comment):'-'
      getDrDetail.video.title = getDrDetail.video.title?getDrDetail.video.title:'-'
      getDrDetail.quality = changeComment(getDrDetail.quality)
      getDrDetail.experience = changeComment(getDrDetail.experience)
      getDrDetail.effect = changeComment(getDrDetail.effect)
      this.getDrDetail = getDrDetail
    })
    this.initEvaluationBox()
  },

}
</script>

<style scoped>
.solid{
  border-top: 1px solid #F5F5F6;
}
  .part1 .grade{
    margin-top: 30px;
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    padding-bottom: 0;
    border-top: 1px solid #F5F5F6;
    box-sizing: border-box;
  }
  .part1 .grade .title{
    display: block;
    width: 100%;
    height: 50px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #F5F5F6;
  }
  .part1 .grade .title2{
    width: 100%;
    height: 65px;
    margin-top: 0;
    padding-top: 30px;
    box-sizing: border-box;
  }
  .part1 .grade .comment{
    width: 100%;
    background: #F8F8F8;
    border-radius: 6px;
    padding: 20px 30px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #888888;
    line-height: 32px;
  }

  .part1 .grade .gradeContent{
    width: 100%;
    height: 160px;
  }
  .part1 .grade .gradeContent .scort{
    padding-left: 360px;
    height: 60px;
    box-sizing: border-box;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__icon{
    font-size: 60px;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__text{
    font-size: 40px;
  }
  .part1 .grade .gradeContent .tags{
    margin-top: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
  }
  .part1 .grade .gradeContent .tags span{
    padding: 12px 20px;
    margin: 0 10px;
    font-size: 16px;
    background: #FFF2EB;
    border-radius: 6px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF6F28;
    line-height: 32px;
  }
  .part1 .grade .gradeContent .tags2{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 0 120px;
    box-sizing: border-box;

  }

  .part1 .grade .gradeContent .tags2 .tagItem{
    margin-top: 40px;
    width: 260px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(1){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(2){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF9A16;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem img{
    float: left;
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-left: 17px;
    margin-right: 11px;
  }

  .part1Echar1Nodata{
    position: absolute;
    width: 1170px;
    height: 430px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .part1Echar2Nodata{
    position: absolute;
    width: 1170px;
    height: 430px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .part1Echar2Nodata{
    position: absolute;
    width: 1170px;
    height: 450px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .noData{
    margin: auto;
    text-align: center;
    color: #999;
  }
  .noData img{
    display: block;
    margin: auto;
    margin-bottom: 30px;
  }

  .detailContainer .part{
    width: 100%;
    padding: 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .detailContainer .part1{
    overflow: hidden;
  }
  .part1 .topName{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
  }
  .part1 h3{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .part1 .topInfo{
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid #EAEAEA;
  }
  .part1 .topInfo span{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .topInfo i{
    display: inline-block;
    width: 1px;
    height: 10px;
    margin: 0 14px;
    background: #EAEAEA;
  }
  .part1 .content{
    width: 100%;
    height: 100px;
    margin-top: 30px;
  }
  .part1 .content .backImg{
    float: left;
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .part1 .content .backImg::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
  }
  .part1 .content .backImg::after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 40px;
    height: 40px;
    margin: auto;
    background: url("./images/icon_play.png") no-repeat center;
    background-size: cover;
  }
  .part1 .content .backImg img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .part1 .content .contentDetail{
    float: left;
    width: 260px;
    margin-left: 30px;
  }
  .part1 .content .contentDetail a{
    display: block;
  }
  .part1 .content .contentDetail p a{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
  .part1 .content .contentDetail span a{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .content .contentRight{
    float: right;
    margin-top: 36px;
  }
  .part1 .content .contentRight .rightItem{
    float: left;
    width: 140px;
    height: 48px;
    padding-left: 30px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part1 .content .contentRight .rightItem:nth-last-of-type(1){
    border: 0;
  }
  .part1 .content .contentRight .rightItem span{
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .content .contentRight .rightItem i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part1 .index{
    width: 1200px;
    height: 124px;
    margin-top: 40px;
    margin-left: -30px;
    padding-left: 30px;
    background: #FFFAF7;
    box-sizing: border-box;
  }
  .part1 .index .progress1{
    float: left;
    position: relative;
    width: 64px;
    height: 64px;
    margin-top: 30px;
  }
  .part1 .index .progress1 i{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    line-height: 64px;
    text-align: center;
    font-size: 28px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .index span:nth-of-type(1){
    float: left;
    line-height: 124px;
    margin-left: 30px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part1 .index .more{
    float: left;
    margin-top: 50px;
    margin-left: 16px;
    width: 116px;
    height: 24px;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
    text-align: center;
  }
  .part1 .index .more u{
    color: #333;
    margin: 0 3px;
    line-height: 24px;
  }
  .part1 .listItem{
    float: left;
    width: 530px;
    height: 240px;
    margin-right: 80px;
    padding-top: 50px;
    box-sizing: border-box;
  }
  .part1 .listItem:nth-of-type(2n){
    margin-right: 0;
  }
  .part1 .listItem .listTitle{
    float: left;
    width: 50%;
    height: 50px;
    margin-left: 20px;
  }
  .part1 .listItem .listTitle span{
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part1 .listItem .listTitle .more{
    margin-top: 3px;
  }
  .part1 .listItem .toWhere{
    float: right;
    width: 100px;
    height: 34px;
    background: #FF5C00;
    border-radius: 4px;
    font-size: 15px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 34px;
    text-align: center;
  }
  .part1 .listItem ul{
    width: 100%;
    height: 42px;
    margin-top: 90px;
    padding-left: 0;
  }
  .part1 .listItem ul li{
    float: left;
    width: 110px;
    height: 100%;
    margin-left: 20px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part1 .listItem ul li:nth-last-of-type(1){
    border-right: 0;
  }
  .part1 .listItem ul li span{
    display: block;
    margin-bottom: 4px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .listItem ul li i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part1 .listItem .listBottom .bottomTitle{
    display: block;
    margin-top: 90px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .bottomContent{
    width: 100%;
    height: 50px;
    margin-top: 24px;
  }
  .part1 .listItem .listBottom .bottomContent img{
    float: left;
    width: 50px;
    height: 50px;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther{
    float: left;
    width: 80%;
    margin-left: 20px;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther i{
    display: block;
    margin-bottom: 9px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther u{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther span{
    display: inline-block;
    height: 26px;
    margin-right: 10px;
    margin-bottom: 6px;
    padding: 0 10px;
    line-height: 26px;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .analysis{
    width: 90%;
    height: 60px;
    margin-top: 20px;
  }
  .part1 .listItem .listBottom .analysis .analysisItem{
    float: left;
  }
  .part1 .listItem .listBottom .analysis .analysisItem span{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .analysis .analysisItem i{
    position: relative;
    display: block;
    background: #DDDDDD;
    width: 100%;
    height: 6px;
    margin: 7px 0;
    box-sizing: border-box;
  }
  .part1 .listItem .listBottom .analysis .analysisItem i::after{
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 4px;
    height: 6px;
    background: #fff;
  }
  .part1 .listItem .listBottom .analysis .analysisItem:nth-of-type(1) i{
    background: #31C270;
  }
  .part1 .listItem .listBottom .analysis .analysisItem:nth-of-type(2) i{
    background: #FF823B;
  }


  .detailContainer>>>.el-tabs__nav-wrap::after{
    background-color:transparent;
    border-bottom: 1px solid #F5F5F6;
  }
  .detailContainer>>>.el-tabs__item{
    color:#999;
  }
  .detailContainer>>>.el-tabs__item.is-active{
    color: #FF5C00;
  }
  .detailContainer>>>.el-tabs__active-bar{
    background-color:#FF5C00;
  }

  .partTitle {
    width: 100%;
    height: 80px;
  }
  .partTitle .partTitleLeft{
    float: left;
    width: 60%;
  }
  .partTitle .partTitleLeft i{
    float: left;
    width: 1px;
    height: 10px;
    margin: 15px 14px 0;
    background: #EAEAEA;
  }
  .partTitle .partTitleLeft .partTitleLeftTit{
    display: block;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .partTitle .partTitleLeft p{
    float: left;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .partTitle .progress{
    float: right;
  }
  .part .hr{
    width: 1200px;
    height: 1px;
    margin-left: -30px;
    border-bottom: 1px solid #F5F5F6;
  }
  .partTitle .more{
    float: right;
    width: auto;
    padding: 0 4px;
    margin-top: 13px;
    margin-right: 30px;
  }
  .ItemContainer{
    float: left;
    margin-top: 30px;
    margin-right: 30px;
    width: 554px;
  }
  .ItemContainer .ItemTitle{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }

  .title2{
    display: block;
    margin-top: 30px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .more{
    display: block;
    width: 128px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .more em{
    color: #333;
    font-style: normal;
    margin: 0 3px;
  }
  .progress{
    float: left;
    position: relative;
    width: 50px;
    height: 50px;
  }
  .progress i{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .clear:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear {
    *zoom: 1;
  }
  .detailContainer{
    width: 1200px;
    margin: 20px auto;
  }
  /* .part2{
    height: 1240px;
    margin-top: 40px;
  }
  .part2 .title2{
    margin-bottom: 10px;
  }
  .part2 .title2 .block{
    float: right;
  }
  .part3 .chooseTime,
  .part2 .chooseTime{
    float: right;
    margin-top: -52px;
  }
  .detailContainer>>>.el-input__inner{
    border: 0;
  }
  .part2 .chooseTime .time{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
  }
  .part2 .chooseTime .chooseTimeHr{
    display: inline-block;
    margin: 0 18px;
    width: 1px;
    height: 12px;
    background: #EAEAEA ;
  }
  .part2>>>.el-dropdown-menu__item:focus,
  .part3>>>.el-dropdown-menu__item:focus{
    color: #FF5C00;
    background: #F5F5F5;
  }
  .part2>>>.el-dropdown-menu__item:not(.is-disabled):hover,
  .part3>>>.el-dropdown-menu__item:not(.is-disabled):hover{
    color: #FF5C00;
    background: #F5F5F5;
  }
  .part2 #detailPart2Echart1{
    width: 100%;
    height: 430px;
    margin-top: 20px;
  }
  .part2 #detailPart2Echart2{
    width: 100%;
    height: 430px;
    margin-top: 30px;
  }




  .part3{
    height: 650px;
    margin-top: 40px;
  }
  .part3 #detailPart3Echart1{
    width: 100%;
    height: 430px;
    margin-top: 30px;
  }


  .part4{
    height: 640px;
    margin-top: 40px;
  }
  .part4 .ItemContainer:nth-of-type(2n){
    margin-right: 0;
  }
  .part4 .ItemContainer .part4List1{
    overflow: hidden;
    padding-left: 0;
  }
  .part4 .ItemContainer .part4List1 li{
    float: left;
    width: 130px;
    height: 48px;
    padding-left: 20px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part4 .ItemContainer .part4List1 li:nth-last-of-type(1){
    border: 0;
  }
  .part4 .ItemContainer .part4List1 li span{
    display: block;
    margin-bottom: 6px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
  }
  .part4 .ItemContainer .part4List1 li i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part4 .ItemContainer .part4List2{
    padding-left: 0;
  }
  .part4 .ItemContainer .part4List2 li span{
    display: inline-block;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part4 .ItemContainer .part4List2 li span:nth-of-type(1){
    width: 70px;
  }
  .part4 .ItemContainer .part4List2 li span:nth-of-type(2){
    color: #999;
  }
  .part4 .ItemContainer .part4List2 li i{
    display: inline-block;
    width: 16px;
    margin: 0 15px 14px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF6F28;
  }
  .part4 #detailPart4Echart1{
    width: 554px;
    height: 360px;
  }
  .part4 #detailPart4Echart2{
    width: 554px;
    height: 300px;
    margin-top: 40px;
  }

  .part5{
    height: 1410px;
    margin-top: 40px;
  }
  #detailPart5Echart1{
    width: 570px;
    height: 260px;
  }
  #detailPart5Echart2{
    width: 570px;
    height: 260px;
  }
  .part5 .userChoose{
    width: 100%;
    height: 96px;
    border-bottom: 1px solid #F5F5F6;
  }
  .part5 .userChoose span{
    float: left;
    line-height: 96px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5 .userChoose i{
    float: left;
    margin-top: 30px;
    margin-left: 10px;
    padding: 0 17px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    background: #F4F4F5;
    border-radius: 2px;
  }
  .part5 .userChoose i.active{
    background: #FF7936;
    color: #fff;
  }

  .part5 .title2{
    margin-bottom: 10px;
    margin-top: 0;
  }
  .part5 .part5Line1{
    width: 100%;
    height: 350px;
    margin-top: 30px;
  }
  .part5 .part5Line1 .part5Chart1Container{
    float: left;
    position: relative;
    width: 50%;
  }
  .part5 .part5Line1 .part5Chart1Container .left{
    position: absolute;
    bottom: 30px;
    left: 30px;
    width: 12px;
    height: 84px;
    background-image: linear-gradient(to bottom, #38a1ff, #e0f1ff);
  }

  .part5 .part5Line1 .part5Chart1Container .left::before{
    content: "高";
    position: absolute;
    bottom: 90px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5 .part5Line1 .part5Chart1Container .left::after{
    content: "低";
    position: absolute;
    bottom: -24px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5 .more{
    width: auto;
    text-align:left;
    background: transparent;
    font-size: 14px;
  }
  .part5 .part5Line1 .part5Chart2Container{
    float: left;
    width: 50%;
    padding-left: 60px;
    box-sizing: border-box;
  }
  .part5 .part5Line1 .part5Chart2Container>>>.el-progress-bar__outer{
    cursor: pointer;
  }
  .part5 .part5Line1 .part5Chart2Container>>>.el-progress-bar__outer:hover .el-progress-bar__inner{
    background:#1676E4;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress{
    position: relative;
    float: right;
    width: 460px;
    margin-top: 30px;
    padding-right: 60px;
    box-sizing: border-box;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress span{
      position: absolute;
      left: -50px;
      font-size: 14px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #333333;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress>>>.el-progress{
    margin-bottom: 24px;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress>>>.el-progress-bar__inner{
    background: linear-gradient(90deg, #1A7DFC, #4DACFC);
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress>>>.el-progress__text{
    color: #2784FF;
  }
  .part5 .part5Echart3Container{
    float: left;
    width: 33%;
    height: 360px;
    margin-top: 40px;
    border-right: 1px solid #F5F5F6;
  }
  .part5 #detailPart5Echart3{
    width: 360px;
    height: 220px;
    margin-top: 20px;
  }
  .part5 .part5Echart3Container .bottom{
    width: 100px;
    height: 40px;
    margin-top: 20px;
    margin-left: 30px;
    overflow: hidden;
  }
  .part5 .part5Echart3Container .bottom img{
    float: left;
    width: 30px;
    height: 30px;
    margin-top: 4px;
  }
  .part5 .part5Echart3Container .bottom .bottomRight{
    float: left;
    margin-left: 10px;
  }
  .part5 .part5Echart3Container .bottom .bottomRight span{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part5 .part5Echart3Container .bottom .bottomRight i{
    display: block;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #40A0FC;
  }
  .part5 .part5Echart3Container .bottom:nth-of-type(2){
    float: right;
    margin-right: 30px;
  }
  .part5 .part5Echart4Container{
    float: left;
    width: 33%;
    height: 360px;
    margin-top: 40px;
    padding: 0 20px;
    border-right: 1px solid #F5F5F6;
    box-sizing: border-box;
  }
  .part5 #detailPart5Echart4{
    width: 340px;
    height: 280px;
    margin-top: 10px;
  }
  .part5 .part5Echart5Container{
    float: left;
    width: 33%;
    height: 360px;
    margin-top: 40px;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .part5 #detailPart5Echart5{
    width: 340px;
    height: 220px;
    margin-top: 60px;
  }
  .part5 .part5Echart6Container{
    float: left;
    width: 48%;
    height: 320px;
    margin-top: 40px;
    padding: 0 20px;
    box-sizing: border-box;
    border-right: 1px solid #F5F5F6;
  }
  .part5 #detailPart5Echart6{
    width: 500px;
    height: 260px;
    margin-top: 10px;
  }
  .part5 .part5Echart7Container{
    float: left;
    width: 50%;
    height: 320px;
    margin-top: 40px;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .part5 #detailPart5Echart7{
    width: 560px;
    height: 260px;
    margin-top: 10px;
  }
  .part6{
    height: 480px;
    margin-top: 40px;
  }
  .part6 .part6Echart1Container{
    float: left;
    width: 50%;
    height: 340px;
  }
  .part6 .part6Echart2Container{
    float: left;
    width: 50%;
    height: 340px;
  }
  .part6 #detailPart6Echart2{
    width: 400px;
    height: 220px;
    margin-top: 50px;
    margin-left: 90px;
  } */
  .hotword {
      position: relative;
      margin-top: 30px;
      margin-left: 90px;
      width: 340px;
      height: 260px;
  }
  .hotword  span{
      position: absolute;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(1){
      top: 80px;
      left: 80px;
      font-size: 60px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(2){
      top: 54px;
      left: 100px;
      font-size: 24px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(3){
      top: 56px;
      left: 200px;
      font-size: 20px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(4){
      top: 160px;
      left: 110px;
      font-size: 20px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(5){
      top: 180px;
      left: 160px;
      font-size: 20px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(6){
      top: 160px;
      left: 220px;
      font-size: 18px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(7){
      top: 30px;
      left: 120px;
      font-size: 16px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(8){
      top: 100px;
      left: 10px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(9){
      top: 130px;
      left: 26px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(10){
      top: 200px;
      left: 80px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(11){
      top: 200px;
      left: 240px;
      font-size: 14px;
      color: #38A1FF;
  }
  .agentBox{
    margin-top: 20px;
    display: inline-flex;
    align-items: center;
    width: 100%;
    height: 42px;
  }
  .agentReply{
    width: 120px;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }
  .agentReplyBtn{
    width: 120px;
    height: 42px; 
    margin-left: 10px;
    font-size: 14px;
  }
  .agentReplyBoardBox{
    width: 100%;
    height: 100%;
    background: #FFFAF8;
    border-radius: 4px;
    border: 1px solid #FFE2D3;
    padding: 13px;
    box-sizing: border-box;
  }
  .agentReplyBoardTitle{
    font-weight: 500;
    font-size: 14px;
    color: #FF6F28;
  }
  .agentReplyBoard{
    font-size: 14px;
    color:#666666;
    line-height: 24px;
  }


</style>